import React from "react";

// Elfi si Elang Pintar — friendly mascot eagle
export default function Mascot({ className = "", size = 96 }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Elfi si Elang Pintar"
    >
      <circle cx="60" cy="62" r="42" fill="#0D9488" />
      <circle cx="60" cy="62" r="42" fill="url(#g1)" fillOpacity="0.25" />
      {/* body */}
      <ellipse cx="60" cy="70" rx="30" ry="32" fill="#14B8A6" />
      <ellipse cx="60" cy="78" rx="19" ry="22" fill="#F8FAFC" />
      {/* wings */}
      <path d="M32 60c-10 2-16 12-14 24 8-2 16-8 18-16z" fill="#0F766E" />
      <path d="M88 60c10 2 16 12 14 24-8-2-16-8-18-16z" fill="#0F766E" />
      {/* face */}
      <circle cx="51" cy="56" r="9" fill="#fff" />
      <circle cx="69" cy="56" r="9" fill="#fff" />
      <circle cx="52" cy="57" r="4.2" fill="#1E293B" />
      <circle cx="68" cy="57" r="4.2" fill="#1E293B" />
      <circle cx="53.5" cy="55.5" r="1.4" fill="#fff" />
      <circle cx="69.5" cy="55.5" r="1.4" fill="#fff" />
      {/* beak */}
      <path d="M60 62l-6 6h12z" fill="#F59E0B" />
      {/* graduation cap */}
      <rect x="40" y="34" width="40" height="7" rx="2" fill="#1E293B" transform="rotate(-4 60 37)" />
      <path d="M44 38l16-7 16 7-16 6z" fill="#334155" />
      <circle cx="78" cy="33" r="2.4" fill="#F59E0B" />
      <path d="M78 33v7" stroke="#F59E0B" strokeWidth="1.6" />
      <defs>
        <linearGradient id="g1" x1="20" y1="20" x2="100" y2="104" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
